import { Injectable, inject } from '@angular/core'
import { CdcTokenResponse } from '@app/core/models/custom/auth.model'
import { GigyaAuthData } from '@app/core/models/custom/gigya.model'
import { Observable } from 'rxjs'
import { CustomAuthAdapter } from './auth.adapter'

@Injectable({ providedIn: 'root' })
export class CustomAuthConnector {
  private readonly authAdapter = inject(CustomAuthAdapter)

  getCdcToken (authData: GigyaAuthData): Observable<CdcTokenResponse> {
    return this.authAdapter.getCdcToken(authData)
  }
}
